import React from 'react';
import { Phone, MessageSquare, Star } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../data/mock';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/3441895/pexels-photo-3441895.jpeg"
          alt="Expert mechanic at work"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/85 to-gray-900/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          {/* Rating Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6 animate-in fade-in slide-in-from-bottom-4 duration-700">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-white font-semibold">{businessInfo.rating} Stars</span>
            <span className="text-gray-300">• Trusted by Beaverton</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-in fade-in slide-in-from-bottom-6 duration-700 delay-100">
            Beaverton's Most Trusted{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">
              Auto Electric
            </span>{' '}
            & Repair
          </h1>

          {/* Sub-headline */}
          <p className="text-xl sm:text-2xl text-gray-200 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200">
            Honest diagnostics. Fair prices. Zero upselling. We handle the complex electrical issues and general repairs that other shops can't.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300">
            <a href="tel:5037094366">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-8 py-6 text-lg rounded-xl flex items-center gap-3 shadow-2xl hover:shadow-blue-500/50 hover:scale-105 transition-all w-full sm:w-auto">
                <Phone className="w-5 h-5" />
                Call (503) 709-4366
              </Button>
            </a>
            <Button
              onClick={scrollToContact}
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-bold px-8 py-6 text-lg rounded-xl border-2 border-white/30 flex items-center gap-3 hover:scale-105 transition-all w-full sm:w-auto"
            >
              <MessageSquare className="w-5 h-5" />
              Request a Quote
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 animate-in fade-in slide-in-from-bottom-12 duration-700 delay-400">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4">
              <div className="text-3xl font-bold text-amber-400 mb-1">10+</div>
              <div className="text-gray-300 text-sm">Years of Expertise</div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4">
              <div className="text-3xl font-bold text-amber-400 mb-1">1000+</div>
              <div className="text-gray-300 text-sm">Cars Serviced</div>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4">
              <div className="text-3xl font-bold text-amber-400 mb-1">4.8★</div>
              <div className="text-gray-300 text-sm">Customer Rating</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
